module.exports = __webpack_public_path__ + "img/Country4-2.ad0eceaa.png";